import {React, FC} from 'external/react'
import {styled} from 'external/material'

import SelectTemplate from './Templates/SelectTemplate'
import TemplatesMenu from './Templates/TemplatesMenu'
import SavePlan from './Buttons/SavePlan'
import CancelPlan from './Buttons/CancelPlan'

type PlanningTopbarProps = {
  rd?: boolean
  className?: string
}

const StyledPlanningTopbar = styled('div')(planningTopbarStyles as any)

const PlanningTopbar: FC<PlanningTopbarProps> = props => {
  const {rd, children, className} = props
  return (<StyledPlanningTopbar className={className}>
      {children}
      <TemplatesMenu rd={rd}/>
      <SelectTemplate />
      <div className="filler" />
      <CancelPlan />
      <SavePlan />
   </StyledPlanningTopbar>
  )
}

export  {PlanningTopbar as default}

function planningTopbarStyles() {
  return {
    minHeight: "40px",
    marginTop: "10px",
    gap: 20,
    display: "flex",
    "& > .filler": {
      flexGrow: 1
    },
  }
}